<template>
  <footer>
      <h1>Let your Vines Service Experts technician know you are interested today! <a class="number" href="tel:843-310-3530">843-310-3530</a> </h1>
  </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            phone: '7137140707',
        };
    },
    filters: {
        phoneNumber(p) {
            return `${p.slice(0, 3)}-${p.slice(3, 6)}-${p.slice(6)}`;
        },
    },
};
</script>

<style lang="scss" scoped>
footer {
    padding: 1.5rem;
    background-color: #5B86FF;
    text-align: center;
}

h1 {
    font-size: 22.78px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0;
    margin-bottom: 28px;
}

p {
    font-size: 22.78px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0;
    margin-bottom: 48px;
}

ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

ul > li {
    font-size: 20.25px;
    font-weight: 600;
    line-height: 24px;
    background-color: #6D94FF;
    padding: 1rem;
    border-radius: 3px;
    &:nth-child(n+2) {
        margin-top: 8px;
    }
}

.number {
    font-size: 20px;
    font-weight: 500;
    text-decoration: none;
    color: #F8F837;
  
}

.badge-container {
    display: flex;
    align-items: center;
    justify-content: center;
    .badge-link {
        display: flex;
        &:first-child {
            justify-content: flex-end;
            margin-right: 24px;
        }
        &:last-child {
            justify-content: flex-start;
        }
    }
    .app-badge-img {
        width: 70%;
    }
}
</style>